import React from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'

const MetaDataHelmet = ({ title, description }) => (
  <Helmet titleTemplate="%s | CGTrader">
    <title>{title}</title>
    <meta name="description" content={description} />
  </Helmet>
)

MetaDataHelmet.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
}

export default MetaDataHelmet
